import React from 'react';
import * as IMAGES from '../Images';

import './Loader.css';

class Loader extends React.Component {
  constructor(props) {
    super(props);

    let companyData = {};
    try {
      companyData = JSON.parse(localStorage.getItem('companyData') || '{}');
    } catch (error) {
      companyData = {};
    }

    this.logo = companyData.logo || IMAGES.APP_LOGO;

    this.state = {};
  }

  render = () => {
    return (
      <div className="loader-container">
        <img src={this.logo} alt="Company Logo" style={{ width: '325px' }} />
      </div>
    );
  };
}

export default Loader;